import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
export function usePixNavigation() {
    const navigate = useNavigate();
    const handleBackToList = useCallback(() => {
        navigate('/conta-pj/pix');
    }, [navigate]);
    const handleFirstKey = useCallback(() => {
        navigate('criar');
    }, [navigate]);
    const handleCreatePixKey = useCallback(() => {
        navigate('criar');
    }, [navigate]);
    const handlePixCopyPaste = useCallback(() => {
        navigate('/conta-pj/pagar/pix-copia-e-cola');
    }, [navigate]);
    const handlePixTransfer = useCallback(() => {
        navigate('transferir');
    }, [navigate]);
    const handleNavigateToConfirmation = useCallback((protocolId, createdKey, keyType) => {
        navigate('criar', {
            state: {
                showConfirmation: true,
                protocolId,
                createdKey,
                keyType,
            },
        });
    }, [navigate]);
    return {
        handleBackToList,
        handleFirstKey,
        handleCreatePixKey,
        handlePixCopyPaste,
        handlePixTransfer,
        handleNavigateToConfirmation,
    };
}
